import axios from "axios";
import { call, put, select, takeEvery, takeLatest } from "redux-saga/effects";
import validate from "validate.js";
import { toast } from "react-toastify";
import storage from "services/storage";
import constants from "constants";
import actions from "actions";
import { loginStory } from "./stories/login.js";
import { push } from "redux-router";
import { updateUser } from "../actions/users.js";
import { cleanWebinars } from "../actions/webinars.js";
const { addErrorsSaga } = actions;

const {
  LOGIN_SAGA,
  LOGOUT_SAGA,
  PERFORM_LOGOUT,
  ERROR_TYPE_LOGIN_ERROR,
  SEND_CONFIRM_CODE,
  API_ADMIN_LOGIN,
  ADMIN_CONFIRM_LOGIN,
  API_ADMIN_CONFIRM_CODE,
  ADMIN_RESEND_CONFIRM_CODE,
  API_ADMIN_RESEND_CONFIRM_CODE,
  API_ADMIN_LOGOUT,
} = constants;

function* loginAdmin(data) {
  const user = data.user;
  const session = {
    token: data.token,
  };

  yield put(updateUser(user, session));
  storage.setSessionData(user, session);
  storage.setAdminSuperToken(data.super_token);
  yield call(successNotification, user);
  yield put(push("/"));
}

const apiLogoutAdmin = () => axios.put(API_ADMIN_LOGOUT);

const apiSendConfirmationCode = (body) =>
  axios.post(API_ADMIN_LOGIN, body, {
    headers: {
      Authorization: `super_token=${storage.getAdminSuperToken()}`,
    },
  });

const apiConfirmAdminLogin = (body) => axios.put(API_ADMIN_CONFIRM_CODE, body);

const apiResendConfirmationCode = (body) =>
  axios.put(API_ADMIN_RESEND_CONFIRM_CODE, body);

const successNotification = ({ first_name, last_name }) => {
  toast.success(
    `Welcome, ${validate.capitalize(
      validate.prettify(first_name)
    )} ${validate.capitalize(validate.prettify(last_name))}`
  );
};
function* login({ email, password, redirect }) {
  try {
    const response = yield call(loginStory, email, password);
    const user = response.data.user;
    yield call(successNotification, user);

    if (storage.getJoinWebinarId()) {
      yield put(push(`/join_webinar/${storage.getJoinWebinarId()}`));
      return;
    }

    if (storage.getJoinGroupId()) {
      yield put(push(`/join_group/${storage.getJoinGroupId()}`));
      return;
    }

    // const nonLoggedInUrl = localStorage.getItem("nonLoggedInUrl");

    // if (nonLoggedInUrl) {
    //   return yield put(push(nonLoggedInUrl));
    // }

    // if (localStorage.getItem("nonLoggedInUrl")) {
    //   console.log(redirect || localStorage.getItem("nonLoggedInUrl"));
    //   yield put(push(redirect || localStorage.getItem("nonLoggedInUrl")));
    // }
    yield put("/");
  } catch (e) {
    yield put(addErrorsSaga(ERROR_TYPE_LOGIN_ERROR, e.response));
  }
}

function* sendConfirmationCode({ payload }) {
  try {
    const { data } = yield call(apiSendConfirmationCode, payload);
    if (data.user) {
      yield call(loginAdmin, data);
      return;
    }
    toast.success(data.message);
    yield put(push(`/users/sign_in/admin/confirm?token=${data.auth_token}`));
  } catch (e) {
    toast.error("This email or password is not recognised");
  }
}

function* confirmAdminLogin({ payload }) {
  try {
    const response = yield call(apiConfirmAdminLogin, payload);
    yield call(loginAdmin, response.data);
    // const user = response.data.user;
    // const session = {
    //   token: response.data.token,
    // };

    // yield put(updateUser(user, session));
    // storage.setSessionData(user, session);
    // storage.setAdminSuperToken(response.data.super_token);
    // yield call(successNotification, user);
    // yield put(push(localStorage.getItem("nonLoggedInUrl")));
  } catch (e) {
    const message = e.response.data.error_message;
    toast.error(message);
  }
}

function* adminResendConfirmCode({ payload }) {
  try {
    const { data } = yield call(apiResendConfirmationCode, payload);
    toast.success(data.message);
    yield put(push(`/users/sign_in/admin/confirm?token=${data.auth_token}`));
  } catch (e) {
    const message = e.response.data.error;
    toast.error(message);
  }
}

function* logout() {
  try {
    const { role } = yield select((state) => state.users.user);
    if (role === "admin") {
      yield call(apiLogoutAdmin);
    }
    yield put(cleanWebinars());
    yield call(storage.purgeSessionData);
    yield put({
      type: PERFORM_LOGOUT,
    });

    yield put(push("/users/sign_in"));
  } catch (e) {
    toast.error(e);
  }
}

function* __loginSaga() {
  yield takeEvery(LOGIN_SAGA, login);
}

function* __logoutSaga() {
  yield takeEvery(LOGOUT_SAGA, logout);
}

function* __sendConfirmationCode() {
  yield takeEvery(SEND_CONFIRM_CODE, sendConfirmationCode);
}

function* __adminConfirmLogin() {
  yield takeEvery(ADMIN_CONFIRM_LOGIN, confirmAdminLogin);
}

function* __adminResendConfirCode() {
  yield takeEvery(ADMIN_RESEND_CONFIRM_CODE, adminResendConfirmCode);
}

export {
  __loginSaga,
  __logoutSaga,
  __sendConfirmationCode,
  __adminConfirmLogin,
  __adminResendConfirCode,
};



// WEBPACK FOOTER //
// ./src/sagas/auth.js